export type SnakeToCamelCase<S extends string> = S extends `${infer T}_${infer U}`
  ? `${T}${Capitalize<SnakeToCamelCase<U>>}`
  : S

type SnakeToCamelCaseKeys<T> =
  T extends Array<infer U>
    ? Array<SnakeToCamelCaseKeys<U>>
    : T extends Record<string, unknown>
      ? {
          [K in keyof T as SnakeToCamelCase<K & string>]: SnakeToCamelCaseKeys<T[K]>
        }
      : T

export default function snakeToCamelCase<T>(obj: T): SnakeToCamelCaseKeys<T> {
  if (obj === null || typeof obj !== 'object') {
    return obj as SnakeToCamelCaseKeys<T>
  }

  if (Array.isArray(obj)) {
    return obj.map(item => snakeToCamelCase(item)) as SnakeToCamelCaseKeys<T>
  }

  const result = {} as Record<string, unknown>

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const camelKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
      result[camelKey] = snakeToCamelCase((obj as Record<string, unknown>)[key])
    }
  }

  return result as SnakeToCamelCaseKeys<T>
}
